@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(819_095_614)
internal val Res.drawable.Aa28: DrawableResource by lazy {
      DrawableResource("drawable:Aa28", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_330_911_518)
internal val Res.drawable.Aa29: DrawableResource by lazy {
      DrawableResource("drawable:Aa29", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(825_008_818)
internal val Res.drawable.Aa3: DrawableResource by lazy {
      DrawableResource("drawable:Aa3", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(610_501_248)
internal val Res.drawable.Aa30: DrawableResource by lazy {
      DrawableResource("drawable:Aa30", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_212_051_578)
internal val Res.drawable.Aa31: DrawableResource by lazy {
      DrawableResource("drawable:Aa31", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_777_603_646)
internal val Res.drawable.Aa32: DrawableResource by lazy {
      DrawableResource("drawable:Aa32", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-715_880_184)
internal val Res.drawable.Aa4: DrawableResource by lazy {
      DrawableResource("drawable:Aa4", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-652_292_976)
internal val Res.drawable.Aa5: DrawableResource by lazy {
      DrawableResource("drawable:Aa5", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(20_292_353)
internal val Res.drawable.Aa6: DrawableResource by lazy {
      DrawableResource("drawable:Aa6", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_884_879_050)
internal val Res.drawable.Aa7: DrawableResource by lazy {
      DrawableResource("drawable:Aa7", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_533_714_853)
internal val Res.drawable.Aa7A: DrawableResource by lazy {
      DrawableResource("drawable:Aa7A", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa7A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(632_198_945)
internal val Res.drawable.Aa7B: DrawableResource by lazy {
      DrawableResource("drawable:Aa7B", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa7B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-907_052_264)
internal val Res.drawable.Aa8: DrawableResource by lazy {
      DrawableResource("drawable:Aa8", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_714_474_004)
internal val Res.drawable.Aa9: DrawableResource by lazy {
      DrawableResource("drawable:Aa9", setOf(
        ResourceItem(setOf(), "${MD}drawable/Aa9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-213_153_648)
internal val Res.drawable.B1: DrawableResource by lazy {
      DrawableResource("drawable:B1", setOf(
        ResourceItem(setOf(), "${MD}drawable/B1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_484_674_972)
internal val Res.drawable.B2: DrawableResource by lazy {
      DrawableResource("drawable:B2", setOf(
        ResourceItem(setOf(), "${MD}drawable/B2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-561_249_287)
internal val Res.drawable.B3: DrawableResource by lazy {
      DrawableResource("drawable:B3", setOf(
        ResourceItem(setOf(), "${MD}drawable/B3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_211_213_017)
internal val Res.drawable.B4: DrawableResource by lazy {
      DrawableResource("drawable:B4", setOf(
        ResourceItem(setOf(), "${MD}drawable/B4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_721_102_425)
internal val Res.drawable.B5: DrawableResource by lazy {
      DrawableResource("drawable:B5", setOf(
        ResourceItem(setOf(), "${MD}drawable/B5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(878_215_286)
internal val Res.drawable.B5A: DrawableResource by lazy {
      DrawableResource("drawable:B5A", setOf(
        ResourceItem(setOf(), "${MD}drawable/B5A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(283_216_745)
internal val Res.drawable.B6: DrawableResource by lazy {
      DrawableResource("drawable:B6", setOf(
        ResourceItem(setOf(), "${MD}drawable/B6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(408_409_745)
internal val Res.drawable.B7: DrawableResource by lazy {
      DrawableResource("drawable:B7", setOf(
        ResourceItem(setOf(), "${MD}drawable/B7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_617_469_267)
internal val Res.drawable.B8: DrawableResource by lazy {
      DrawableResource("drawable:B8", setOf(
        ResourceItem(setOf(), "${MD}drawable/B8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_094_269_149)
internal val Res.drawable.B9: DrawableResource by lazy {
      DrawableResource("drawable:B9", setOf(
        ResourceItem(setOf(), "${MD}drawable/B9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_477_701_243)
internal val Res.drawable.C1: DrawableResource by lazy {
      DrawableResource("drawable:C1", setOf(
        ResourceItem(setOf(), "${MD}drawable/C1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-90_054_397)
internal val Res.drawable.C10: DrawableResource by lazy {
      DrawableResource("drawable:C10", setOf(
        ResourceItem(setOf(), "${MD}drawable/C10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_251_638_526)
internal val Res.drawable.C10A: DrawableResource by lazy {
      DrawableResource("drawable:C10A", setOf(
        ResourceItem(setOf(), "${MD}drawable/C10A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_729_081_023)
internal val Res.drawable.C11: DrawableResource by lazy {
      DrawableResource("drawable:C11", setOf(
        ResourceItem(setOf(), "${MD}drawable/C11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_010_054_415)
internal val Res.drawable.C12: DrawableResource by lazy {
      DrawableResource("drawable:C12", setOf(
        ResourceItem(setOf(), "${MD}drawable/C12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_508_837_495)
internal val Res.drawable.C13: DrawableResource by lazy {
      DrawableResource("drawable:C13", setOf(
        ResourceItem(setOf(), "${MD}drawable/C13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_411_909_148)
internal val Res.drawable.C14: DrawableResource by lazy {
      DrawableResource("drawable:C14", setOf(
        ResourceItem(setOf(), "${MD}drawable/C14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_880_522_770)
internal val Res.drawable.C15: DrawableResource by lazy {
      DrawableResource("drawable:C15", setOf(
        ResourceItem(setOf(), "${MD}drawable/C15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(196_173_945)
internal val Res.drawable.C16: DrawableResource by lazy {
      DrawableResource("drawable:C16", setOf(
        ResourceItem(setOf(), "${MD}drawable/C16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_016_710_895)
internal val Res.drawable.C17: DrawableResource by lazy {
      DrawableResource("drawable:C17", setOf(
        ResourceItem(setOf(), "${MD}drawable/C17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_521_062_661)
internal val Res.drawable.C18: DrawableResource by lazy {
      DrawableResource("drawable:C18", setOf(
        ResourceItem(setOf(), "${MD}drawable/C18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-61_160_636)
internal val Res.drawable.C19: DrawableResource by lazy {
      DrawableResource("drawable:C19", setOf(
        ResourceItem(setOf(), "${MD}drawable/C19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-331_161_468)
internal val Res.drawable.C2: DrawableResource by lazy {
      DrawableResource("drawable:C2", setOf(
        ResourceItem(setOf(), "${MD}drawable/C2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(790_017_892)
internal val Res.drawable.C20: DrawableResource by lazy {
      DrawableResource("drawable:C20", setOf(
        ResourceItem(setOf(), "${MD}drawable/C20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_537_614_536)
internal val Res.drawable.C21: DrawableResource by lazy {
      DrawableResource("drawable:C21", setOf(
        ResourceItem(setOf(), "${MD}drawable/C21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_954_704_376)
internal val Res.drawable.C22: DrawableResource by lazy {
      DrawableResource("drawable:C22", setOf(
        ResourceItem(setOf(), "${MD}drawable/C22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_887_127_680)
internal val Res.drawable.C23: DrawableResource by lazy {
      DrawableResource("drawable:C23", setOf(
        ResourceItem(setOf(), "${MD}drawable/C23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_101_961_653)
internal val Res.drawable.C24: DrawableResource by lazy {
      DrawableResource("drawable:C24", setOf(
        ResourceItem(setOf(), "${MD}drawable/C24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(329_879_452)
internal val Res.drawable.C2A: DrawableResource by lazy {
      DrawableResource("drawable:C2A", setOf(
        ResourceItem(setOf(), "${MD}drawable/C2A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-629_931_513)
internal val Res.drawable.C2B: DrawableResource by lazy {
      DrawableResource("drawable:C2B", setOf(
        ResourceItem(setOf(), "${MD}drawable/C2B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_931_583_757)
internal val Res.drawable.C2C: DrawableResource by lazy {
      DrawableResource("drawable:C2C", setOf(
        ResourceItem(setOf(), "${MD}drawable/C2C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_488_880_713)
internal val Res.drawable.C3: DrawableResource by lazy {
      DrawableResource("drawable:C3", setOf(
        ResourceItem(setOf(), "${MD}drawable/C3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_658_356_340)
internal val Res.drawable.C4: DrawableResource by lazy {
      DrawableResource("drawable:C4", setOf(
        ResourceItem(setOf(), "${MD}drawable/C4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_391_771_926)
internal val Res.drawable.C5: DrawableResource by lazy {
      DrawableResource("drawable:C5", setOf(
        ResourceItem(setOf(), "${MD}drawable/C5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-13_229_290)
internal val Res.drawable.C6: DrawableResource by lazy {
      DrawableResource("drawable:C6", setOf(
        ResourceItem(setOf(), "${MD}drawable/C6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_574_730_628)
internal val Res.drawable.C7: DrawableResource by lazy {
      DrawableResource("drawable:C7", setOf(
        ResourceItem(setOf(), "${MD}drawable/C7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(516_106_242)
internal val Res.drawable.C8: DrawableResource by lazy {
      DrawableResource("drawable:C8", setOf(
        ResourceItem(setOf(), "${MD}drawable/C8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-578_630_295)
internal val Res.drawable.C9: DrawableResource by lazy {
      DrawableResource("drawable:C9", setOf(
        ResourceItem(setOf(), "${MD}drawable/C9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_201_328_416)
internal val Res.drawable.D1: DrawableResource by lazy {
      DrawableResource("drawable:D1", setOf(
        ResourceItem(setOf(), "${MD}drawable/D1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_392_300_335)
internal val Res.drawable.D10: DrawableResource by lazy {
      DrawableResource("drawable:D10", setOf(
        ResourceItem(setOf(), "${MD}drawable/D10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_705_629_119)
internal val Res.drawable.D11: DrawableResource by lazy {
      DrawableResource("drawable:D11", setOf(
        ResourceItem(setOf(), "${MD}drawable/D11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-19_978_242)
internal val Res.drawable.D12: DrawableResource by lazy {
      DrawableResource("drawable:D12", setOf(
        ResourceItem(setOf(), "${MD}drawable/D12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_479_581_937)
internal val Res.drawable.D13: DrawableResource by lazy {
      DrawableResource("drawable:D13", setOf(
        ResourceItem(setOf(), "${MD}drawable/D13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_939_306_740)
internal val Res.drawable.D14: DrawableResource by lazy {
      DrawableResource("drawable:D14", setOf(
        ResourceItem(setOf(), "${MD}drawable/D14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(41_510_049)
internal val Res.drawable.D15: DrawableResource by lazy {
      DrawableResource("drawable:D15", setOf(
        ResourceItem(setOf(), "${MD}drawable/D15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(534_973_272)
internal val Res.drawable.D16: DrawableResource by lazy {
      DrawableResource("drawable:D16", setOf(
        ResourceItem(setOf(), "${MD}drawable/D16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_451_667_068)
internal val Res.drawable.D17: DrawableResource by lazy {
      DrawableResource("drawable:D17", setOf(
        ResourceItem(setOf(), "${MD}drawable/D17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_002_126_308)
internal val Res.drawable.D18: DrawableResource by lazy {
      DrawableResource("drawable:D18", setOf(
        ResourceItem(setOf(), "${MD}drawable/D18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_259_331_432)
internal val Res.drawable.D19: DrawableResource by lazy {
      DrawableResource("drawable:D19", setOf(
        ResourceItem(setOf(), "${MD}drawable/D19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_614_922_846)
internal val Res.drawable.D2: DrawableResource by lazy {
      DrawableResource("drawable:D2", setOf(
        ResourceItem(setOf(), "${MD}drawable/D2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(373_118_223)
internal val Res.drawable.D20: DrawableResource by lazy {
      DrawableResource("drawable:D20", setOf(
        ResourceItem(setOf(), "${MD}drawable/D20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_564_296_073)
internal val Res.drawable.D21: DrawableResource by lazy {
      DrawableResource("drawable:D21", setOf(
        ResourceItem(setOf(), "${MD}drawable/D21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_590_904_070)
internal val Res.drawable.D22: DrawableResource by lazy {
      DrawableResource("drawable:D22", setOf(
        ResourceItem(setOf(), "${MD}drawable/D22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_762_346_898)
internal val Res.drawable.D23: DrawableResource by lazy {
      DrawableResource("drawable:D23", setOf(
        ResourceItem(setOf(), "${MD}drawable/D23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_658_292_810)
internal val Res.drawable.D24: DrawableResource by lazy {
      DrawableResource("drawable:D24", setOf(
        ResourceItem(setOf(), "${MD}drawable/D24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_983_657_865)
internal val Res.drawable.D25: DrawableResource by lazy {
      DrawableResource("drawable:D25", setOf(
        ResourceItem(setOf(), "${MD}drawable/D25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_710_786_559)
internal val Res.drawable.D26: DrawableResource by lazy {
      DrawableResource("drawable:D26", setOf(
        ResourceItem(setOf(), "${MD}drawable/D26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_213_380_621)
internal val Res.drawable.D27: DrawableResource by lazy {
      DrawableResource("drawable:D27", setOf(
        ResourceItem(setOf(), "${MD}drawable/D27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_077_693_372)
internal val Res.drawable.D27A: DrawableResource by lazy {
      DrawableResource("drawable:D27A", setOf(
        ResourceItem(setOf(), "${MD}drawable/D27A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_190_420_740)
internal val Res.drawable.D28: DrawableResource by lazy {
      DrawableResource("drawable:D28", setOf(
        ResourceItem(setOf(), "${MD}drawable/D28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_866_773_835)
internal val Res.drawable.D29: DrawableResource by lazy {
      DrawableResource("drawable:D29", setOf(
        ResourceItem(setOf(), "${MD}drawable/D29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_584_837_124)
internal val Res.drawable.D3: DrawableResource by lazy {
      DrawableResource("drawable:D3", setOf(
        ResourceItem(setOf(), "${MD}drawable/D3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_893_843_851)
internal val Res.drawable.D30: DrawableResource by lazy {
      DrawableResource("drawable:D30", setOf(
        ResourceItem(setOf(), "${MD}drawable/D30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-201_264_276)
internal val Res.drawable.D31: DrawableResource by lazy {
      DrawableResource("drawable:D31", setOf(
        ResourceItem(setOf(), "${MD}drawable/D31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(818_015_233)
internal val Res.drawable.D31A: DrawableResource by lazy {
      DrawableResource("drawable:D31A", setOf(
        ResourceItem(setOf(), "${MD}drawable/D31A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_605_747_436)
internal val Res.drawable.D32: DrawableResource by lazy {
      DrawableResource("drawable:D32", setOf(
        ResourceItem(setOf(), "${MD}drawable/D32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_136_492_908)
internal val Res.drawable.D33: DrawableResource by lazy {
      DrawableResource("drawable:D33", setOf(
        ResourceItem(setOf(), "${MD}drawable/D33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_913_157_154)
internal val Res.drawable.D34: DrawableResource by lazy {
      DrawableResource("drawable:D34", setOf(
        ResourceItem(setOf(), "${MD}drawable/D34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(229_583_717)
internal val Res.drawable.D34A: DrawableResource by lazy {
      DrawableResource("drawable:D34A", setOf(
        ResourceItem(setOf(), "${MD}drawable/D34A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-539_622_113)
internal val Res.drawable.D35: DrawableResource by lazy {
      DrawableResource("drawable:D35", setOf(
        ResourceItem(setOf(), "${MD}drawable/D35.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(560_128_065)
internal val Res.drawable.D36: DrawableResource by lazy {
      DrawableResource("drawable:D36", setOf(
        ResourceItem(setOf(), "${MD}drawable/D36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-849_982_860)
internal val Res.drawable.D37: DrawableResource by lazy {
      DrawableResource("drawable:D37", setOf(
        ResourceItem(setOf(), "${MD}drawable/D37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_056_341_284)
internal val Res.drawable.D38: DrawableResource by lazy {
      DrawableResource("drawable:D38", setOf(
        ResourceItem(setOf(), "${MD}drawable/D38.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_084_888_400)
internal val Res.drawable.D39: DrawableResource by lazy {
      DrawableResource("drawable:D39", setOf(
        ResourceItem(setOf(), "${MD}drawable/D39.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_316_009_759)
internal val Res.drawable.D4: DrawableResource by lazy {
      DrawableResource("drawable:D4", setOf(
        ResourceItem(setOf(), "${MD}drawable/D4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_583_813_878)
internal val Res.drawable.D40: DrawableResource by lazy {
      DrawableResource("drawable:D40", setOf(
        ResourceItem(setOf(), "${MD}drawable/D40.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(185_249_575)
internal val Res.drawable.D41: DrawableResource by lazy {
      DrawableResource("drawable:D41", setOf(
        ResourceItem(setOf(), "${MD}drawable/D41.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-3_528_027)
internal val Res.drawable.D42: DrawableResource by lazy {
      DrawableResource("drawable:D42", setOf(
        ResourceItem(setOf(), "${MD}drawable/D42.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(463_773_303)
internal val Res.drawable.D43: DrawableResource by lazy {
      DrawableResource("drawable:D43", setOf(
        ResourceItem(setOf(), "${MD}drawable/D43.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_763_717_607)
internal val Res.drawable.D44: DrawableResource by lazy {
      DrawableResource("drawable:D44", setOf(
        ResourceItem(setOf(), "${MD}drawable/D44.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_020_995_715)
internal val Res.drawable.D45: DrawableResource by lazy {
      DrawableResource("drawable:D45", setOf(
        ResourceItem(setOf(), "${MD}drawable/D45.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-526_785_552)
internal val Res.drawable.D46: DrawableResource by lazy {
      DrawableResource("drawable:D46", setOf(
        ResourceItem(setOf(), "${MD}drawable/D46.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-232_475_301)
internal val Res.drawable.D46A: DrawableResource by lazy {
      DrawableResource("drawable:D46A", setOf(
        ResourceItem(setOf(), "${MD}drawable/D46A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(199_791_102)
internal val Res.drawable.D47: DrawableResource by lazy {
      DrawableResource("drawable:D47", setOf(
        ResourceItem(setOf(), "${MD}drawable/D47.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-958_151_151)
internal val Res.drawable.D48: DrawableResource by lazy {
      DrawableResource("drawable:D48", setOf(
        ResourceItem(setOf(), "${MD}drawable/D48.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(75_537_764)
internal val Res.drawable.D48A: DrawableResource by lazy {
      DrawableResource("drawable:D48A", setOf(
        ResourceItem(setOf(), "${MD}drawable/D48A.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable1Resources(map: MutableMap<String, DrawableResource>) {
  map.put("Aa28", Res.drawable.Aa28)
  map.put("Aa29", Res.drawable.Aa29)
  map.put("Aa3", Res.drawable.Aa3)
  map.put("Aa30", Res.drawable.Aa30)
  map.put("Aa31", Res.drawable.Aa31)
  map.put("Aa32", Res.drawable.Aa32)
  map.put("Aa4", Res.drawable.Aa4)
  map.put("Aa5", Res.drawable.Aa5)
  map.put("Aa6", Res.drawable.Aa6)
  map.put("Aa7", Res.drawable.Aa7)
  map.put("Aa7A", Res.drawable.Aa7A)
  map.put("Aa7B", Res.drawable.Aa7B)
  map.put("Aa8", Res.drawable.Aa8)
  map.put("Aa9", Res.drawable.Aa9)
  map.put("B1", Res.drawable.B1)
  map.put("B2", Res.drawable.B2)
  map.put("B3", Res.drawable.B3)
  map.put("B4", Res.drawable.B4)
  map.put("B5", Res.drawable.B5)
  map.put("B5A", Res.drawable.B5A)
  map.put("B6", Res.drawable.B6)
  map.put("B7", Res.drawable.B7)
  map.put("B8", Res.drawable.B8)
  map.put("B9", Res.drawable.B9)
  map.put("C1", Res.drawable.C1)
  map.put("C10", Res.drawable.C10)
  map.put("C10A", Res.drawable.C10A)
  map.put("C11", Res.drawable.C11)
  map.put("C12", Res.drawable.C12)
  map.put("C13", Res.drawable.C13)
  map.put("C14", Res.drawable.C14)
  map.put("C15", Res.drawable.C15)
  map.put("C16", Res.drawable.C16)
  map.put("C17", Res.drawable.C17)
  map.put("C18", Res.drawable.C18)
  map.put("C19", Res.drawable.C19)
  map.put("C2", Res.drawable.C2)
  map.put("C20", Res.drawable.C20)
  map.put("C21", Res.drawable.C21)
  map.put("C22", Res.drawable.C22)
  map.put("C23", Res.drawable.C23)
  map.put("C24", Res.drawable.C24)
  map.put("C2A", Res.drawable.C2A)
  map.put("C2B", Res.drawable.C2B)
  map.put("C2C", Res.drawable.C2C)
  map.put("C3", Res.drawable.C3)
  map.put("C4", Res.drawable.C4)
  map.put("C5", Res.drawable.C5)
  map.put("C6", Res.drawable.C6)
  map.put("C7", Res.drawable.C7)
  map.put("C8", Res.drawable.C8)
  map.put("C9", Res.drawable.C9)
  map.put("D1", Res.drawable.D1)
  map.put("D10", Res.drawable.D10)
  map.put("D11", Res.drawable.D11)
  map.put("D12", Res.drawable.D12)
  map.put("D13", Res.drawable.D13)
  map.put("D14", Res.drawable.D14)
  map.put("D15", Res.drawable.D15)
  map.put("D16", Res.drawable.D16)
  map.put("D17", Res.drawable.D17)
  map.put("D18", Res.drawable.D18)
  map.put("D19", Res.drawable.D19)
  map.put("D2", Res.drawable.D2)
  map.put("D20", Res.drawable.D20)
  map.put("D21", Res.drawable.D21)
  map.put("D22", Res.drawable.D22)
  map.put("D23", Res.drawable.D23)
  map.put("D24", Res.drawable.D24)
  map.put("D25", Res.drawable.D25)
  map.put("D26", Res.drawable.D26)
  map.put("D27", Res.drawable.D27)
  map.put("D27A", Res.drawable.D27A)
  map.put("D28", Res.drawable.D28)
  map.put("D29", Res.drawable.D29)
  map.put("D3", Res.drawable.D3)
  map.put("D30", Res.drawable.D30)
  map.put("D31", Res.drawable.D31)
  map.put("D31A", Res.drawable.D31A)
  map.put("D32", Res.drawable.D32)
  map.put("D33", Res.drawable.D33)
  map.put("D34", Res.drawable.D34)
  map.put("D34A", Res.drawable.D34A)
  map.put("D35", Res.drawable.D35)
  map.put("D36", Res.drawable.D36)
  map.put("D37", Res.drawable.D37)
  map.put("D38", Res.drawable.D38)
  map.put("D39", Res.drawable.D39)
  map.put("D4", Res.drawable.D4)
  map.put("D40", Res.drawable.D40)
  map.put("D41", Res.drawable.D41)
  map.put("D42", Res.drawable.D42)
  map.put("D43", Res.drawable.D43)
  map.put("D44", Res.drawable.D44)
  map.put("D45", Res.drawable.D45)
  map.put("D46", Res.drawable.D46)
  map.put("D46A", Res.drawable.D46A)
  map.put("D47", Res.drawable.D47)
  map.put("D48", Res.drawable.D48)
  map.put("D48A", Res.drawable.D48A)
}
